import { render, staticRenderFns } from "./BoxSection.vue?vue&type=template&id=ca6cc57c&scoped=true&"
import script from "./BoxSection.vue?vue&type=script&lang=js&"
export * from "./BoxSection.vue?vue&type=script&lang=js&"
import style0 from "./BoxSection.vue?vue&type=style&index=0&id=ca6cc57c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6cc57c",
  null
  
)

export default component.exports